const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const replaceUrlFilters = (s, r) => s.replace(/(:[^\s?]*)*(?=\?.*|$)/, r);
const removeUrlFilter = (s, f) => s.replace(new RegExp(`(:${ escape(f) })(?=\\?|$|:)`), '');

export {
    removeUrlFilter as removeUrlFilterRegExp,
    replaceUrlFilters as replaceUrlFiltersRegExp,
    escape as escapeRegExp
};